import { AfterViewInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Component, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Mirko3Service } from '../mirko3.service';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfermaComponent } from '../dialog-conferma/dialog-conferma.component';
import { SicotService } from '../sicot.service';
import { User } from '../types/User';

@Component({
  selector: 'app-strutture',
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatTableModule, MatButtonModule, CommonModule, MatDatepickerModule, MatProgressBarModule, MatPaginatorModule, MatIconModule],
  templateUrl: './strutture.component.html',
  styleUrl: './strutture.component.css',
  providers: [provideNativeDateAdapter()]
})
export class StruttureComponent implements AfterViewInit{

  private _operatoriSelezionati: number | undefined;

  @Input() set operatoriSelezionati(value: any[]) {
    this._operatoriSelezionati = value.map(operatori => operatori.id)[0];
}
  @Output() strutturaId = new EventEmitter<any[]>();

  ngAfterViewInit() {
    if (this.dataSource)
    this.dataSource.paginator = this.paginator;
  }


  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator(new MatPaginatorIntl(), ChangeDetectorRef.prototype);


  selectedStrutture: any[] = [];
  disponibilitaSessioneUVM: any[] = [];
  struttura: Struttura[] = [];

  loadinDisponibilitaUVM: boolean = false;
  filtroDisponibilita: boolean = true;
  sceltaDisponibilita: boolean = false;

  displayedColumns: string[] = ['descrizione', 'action'];
  displayedColumnsDisponibilitaSessioneUVM: string[] = ['data', 'oraInizio', 'oraFine', 'struttura', 'StruttureBreve', 'action2'];
  dataSource: any;
  dataSoruceSelected: any;
  dataSoruceDisponibilitaSessioneUVM: any;
  mostraAggiungi: boolean = true;



  get mostraFiltroDisponibilita() {
    return this.filtroDisponibilita;
  }

  get mostraSceltaDisponibilita() {
    return this.sceltaDisponibilita;
  }

  get mostraCaricamentoDisponibilitaUVM() {
    return this.loadinDisponibilitaUVM;
  }

  constructor(private siCotService: SicotService) {

  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    if (this.operatoriSelezionati) {
      console.log('oeratori ricevute:', this.operatoriSelezionati);
  } else {
      console.log('Nessuna operatore ricevuta');
  }
    this.fetchStrutture();
  }




  back() {
    this.sceltaDisponibilita = false;
    this.filtroDisponibilita = true;
  }

  fetchStrutture(): void {
    this.siCotService.getStruttureByOperatori(this._operatoriSelezionati).subscribe(
      (data) => {
        this.struttura = data;
        console.log("Operatore " + this.struttura)
        this.dataSource = new MatTableDataSource<Operatore[]>(data);
        this.dataSource.paginator = this.paginator;
      },
      (error) => {
        console.error('Error fetching Strutture:', error);
      }
    );
  }

  addToSelected(item: any): void {
    this.selectedStrutture.push(item);
    this.dataSoruceSelected = new MatTableDataSource<Struttura[]>(this.selectedStrutture);
    this.mostraAggiungi = false
  }

  svuotaListaStrutture() {
    this.selectedStrutture = [];
    this.dataSoruceSelected = new MatTableDataSource<Struttura[]>(this.selectedStrutture);
    this.mostraAggiungi=true
  }

  rimuoviDaListaStruttureSelezionate(item: any) {
    console.log(item);
    if (item) {
      const index = this.dataSoruceSelected.data.indexOf(item);
      if (index > -1) {
        this.dataSoruceSelected.data.splice(index, 1);
        this.dataSoruceSelected = new MatTableDataSource(this.dataSoruceSelected.data);
        this.mostraAggiungi=true
      }
    }
  }

  saveStrutture(){
    this.strutturaId.emit(this.selectedStrutture)
  }
}


export interface Struttura {
  id: number;
  codice: string;
  denominazione: string;
}

export interface Operatore {
  id: string;
  cognome: string;
  nome: string;
  codiceFiscale: string;
  strutture: Struttura
}







